// @flow

import type { KeyValue } from 'app/developer-v3/components/KeyValueEditor';
import type { StringMap } from 'app/common/types';

const convertParamsToItems = (params: StringMap): Array<KeyValue> =>
  Object.keys(params).map(key => ({ key, value: params[key] }));

const convertItemsToParams = (items: Array<KeyValue>): StringMap =>
  items.reduce((params, item) => ({ ...params, [item.key]: item.value }), {});

export { convertItemsToParams, convertParamsToItems };
